// Privy is the ONLY auth layer of the dashboard (2026-09-21). It is the same
// Privy app as instaswap.com / app.instaswap.com / trade.instaswap.com, so a
// partner who signed in with Google on the trade app has the SAME identity
// (DID + embedded wallet) here. Who they are is decided by ppapi from the
// Privy access token (privyLogin), never by anything the browser claims.
export const PRIVY_APP_ID =
  process.env.REACT_APP_PRIVY_APP_ID || "cmo5qqvvp00mq0cl7tvpvbemk";

export const PRIVY_CONFIG = {
  appearance: {
    theme: "dark",
    accentColor: "#23dc85",
    showWalletLoginFirst: false,
    walletList: ["metamask", "coinbase_wallet", "wallet_connect", "detected_wallets"],
  },
  // Same shape as instaswap.com so a partner sees the same options everywhere.
  embeddedWallets: { createOnLogin: "all-users" },
  loginMethods: ["email", "wallet", "google", "twitter", "discord", "telegram"],
  walletConnectCloudProjectId:
    process.env.REACT_APP_REOWN_PROJECT_ID || undefined,
};

export const PPAPI = "https://ppapi.instaswap.com/formData";

// Cloudflare Turnstile widget "partners.instaswap.com signup" (managed mode). The
// site key is public; ppapi verifies the token server-side on privyRegister.
export const TURNSTILE_SITE_KEY =
  process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAAFjtIfaOJNMedDX1";
